import {Injectable} from "@angular/core";
import {Subject, Subscription} from "rxjs";
import {EventData} from "compob2b-libs";
import {filter, map} from "rxjs/operators";

@Injectable({
  providedIn: 'root',
})
export class EventCartService {
  private subject$ = new Subject<EventData>();

  emit(event: EventData) {
    console.log('Event Emited:', event);
    this.subject$.next(event);
  }

  on(eventName: string, action: any): Subscription {
    return this.subject$.pipe(
      filter((e: EventData) => e.name === eventName),
      map((e: EventData) => e.data)
    ).subscribe(action);
  }
}
